import { defineStore } from "pinia";
import { type Ref, ref } from "vue";

export const useGeneralStore = defineStore("general", () => {
  const fullscreen = ref<boolean>(false);
  const accountManagerMail: Ref<string | undefined> = ref(undefined);

  const toggleFullscreen = (active: boolean) => {
    fullscreen.value = active;
  };

  return {
    fullscreen,
    toggleFullscreen,
    accountManagerMail,
  };
});
